/*
 * Module that sets up (perfect) scrollbars and manages their presentation 
*/

rs.module("common/lrs-scroll",

    ["common/perfect-scrollbar"],

    function (perfectScrollbar) {

        //
        // Initialize
        //
        function initialize() {

            $(".lrs-scroll").each(function () {
                initializeScroll(this);
            });

            // When window resizes, reevaluate if the indicator needs to be shown
            $(window).resize(_.debounce(function () {

                $(".lrs-scroll").each(function () {
                    $(this).toggleClass("_scroll-indicator", (this.scrollHeight > this.clientHeight) && $(this).scrollTop() == 0);
                });

            }, 200));
        }

        //
        // Initialize a given container for scrolling.  Any container with the class lrs-scroll will get initialized when the page is rendered.
        // However, we need a way to manually initialize any containers that were added via ajax.  Exporting this function allows us to do that.
        //
        function initializeScroll(scrollContainer) {

            // setup perfect scrollbar for each container
            perfectScrollbar.createInstance(scrollContainer, { suppressScrollX: true });

            // We need to get the scroll container as a DOM object so that we can use the properties scrollHeight and clientHeight
            // Since this is an exported function we don't know if the caller is sending us a DOM object or a jQuery object, this ensures we are using the DOM object either way
            var scrollContainerDOM = scrollContainer.jquery ? scrollContainer[0] : scrollContainer;

            // When the scroll container is rendered, add class to show scroll indicator if the section is scrollable and is scrolled all the way to the top
            $(scrollContainer).toggleClass("_scroll-indicator", (scrollContainerDOM.scrollHeight > scrollContainerDOM.clientHeight) && $(scrollContainer).scrollTop() == 0);

            // On scroll, toggle indicator based on scroll position (Only show if scrolled all the way to the top)
            $(scrollContainer).scroll(function () {
                $(this).toggleClass("_scroll-indicator", $(this).scrollTop() == 0);
            });
        }

        // Exported public API
        var exports = {
            initialize,
            initializeScroll
        };

        return exports;
    }
);